import { action } from 'typesafe-actions';

import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { ICheckNotification } from 'APIPackage/MainModule/interfaces/ICheckNotification';
import { IOpenApiInfo } from 'APIPackage/MainModule/interfaces/IOpenApiInfo';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';

import { CoreActionsEnum } from '../enums/CoreActionsEnum';

export const coreSetLoading = (value: boolean) => action(CoreActionsEnum.CORE_SET_LOADING, { value });
export const coreSetDeepLoading = (value: boolean) => action(CoreActionsEnum.CORE_DEEP_SET_LOADING, { value });
export const coreSetLoadingProgress = (value?: number) => action(CoreActionsEnum.CORE_SET_LOADING_PROGRESS, { value });
export const coreSetAnnounceHeight = (value: number | undefined) =>
  action(CoreActionsEnum.CORE_SET_ANNOUNCE_HEIGHT, { value });
export const setLawInterfaceAction = (value: LawInterfacesEnum) =>
  action(CoreActionsEnum.CORE_SET_LAW_INTERFACE, { value });
export const coreSetPublicPortalURL = (url: string) => action(CoreActionsEnum.CORE_SET_PUBLIC_PORTAL_URL, { url });
export const coreSetVisibleCheckPluginModal = (visible: boolean) =>
  action(CoreActionsEnum.CORE_SET_VISIBLE_CHECK_PLUGIN_MODAL, { visible });
export const coreSetNotificationInfo = (notificationInfo: ICheckNotification | undefined) =>
  action(CoreActionsEnum.CORE_SET_NOTIFICATION_INFO, { notificationInfo });
export const coreGetNotificationInfo = () => action(CoreActionsEnum.CORE_GET_NOTIFICATION_INFO);
export const coreRemoveFirstNotificationInfo = () => action(CoreActionsEnum.CORE_REMOVE_FIRST_NOTIFICATION_INFO);
export const coreGetOpenApiInfo = () => action(CoreActionsEnum.CORE_GET_OPEN_API_INFO);
export const coreSetOpenApiInfo = (openApiInfo?: IOpenApiInfo) =>
  action(CoreActionsEnum.CORE_SET_OPEN_API_INFO, { openApiInfo });
export const coreSetOptionName = (optionName: CommonCatalogsNamesEnum) =>
  action(CoreActionsEnum.CORE_SET_OPTION_NAME, { optionName });
